import {Enum} from 'enumify';

export default class DisplayType extends Enum {}

DisplayType.initEnum({
  LENOVO_10_INCH: {
    deviceName: '10" Tablet',
    deviceType: 'TABLET',
    deviceCode: 'LENOVO_TB_10',
  },
  SAMSUNG_18_INCH: {
    deviceName: '23" Acer',
    deviceType: 'ANDROID_PC',
    deviceCode: 'ACER_23',
  },
  ANDROID_BOX: {
    deviceName: 'Android Box',
    deviceType: 'ANDROID_BOX',
    deviceCode: 'ANDROID_BOX',
  },
});



// WEBPACK FOOTER //
// ./src/constants/DisplayType.js